import { axiosInstance } from "@/axios/interceptors";
import type { SearchListParam, AnnounceContact, AnnounceRequestFile, PaymentInfo, AnnounceFile, Announce } from "@/common/types";
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
export default {
  announceList: async (data: any) => {
    return await axiosInstance.get(`announces`, { params: data });
  },
  announceDetail: async (seq: number) => {
    return await axiosInstance.get(`announces/${seq}`);
  },

  repuestAnnounceFile(seq: number, data: AnnounceRequestFile) {
    return axiosInstance.post(`/announces/${seq}/request-files`, data);
  },

  announceUploadFile: async (seq: number, dtoPart: any | any[], multifiles: File | File[]) => {
    const formData = new FormData();

    // JSON 데이터 추가
    const dtoArray = Array.isArray(dtoPart) ? dtoPart : [dtoPart]; // 항상 배열로 변환
    formData.append("fileinfos", new Blob([JSON.stringify(dtoArray)], { type: "application/json" }));

    // 파일 추가
    if (Array.isArray(multifiles)) {
      multifiles.forEach((file) => {
        formData.append("multiparts", file);
      });
    } else {
      formData.append("multiparts", multifiles);
    }

    // 요청 보내기
    return axiosInstance.post(`announces/${seq}/attach-files`, formData);
  },

  downloadAnnounceFile: async (공고순번: number, 저장순번: number, 파일명: string) => {
    try {
      const response = await axiosInstance.get(`announces/${공고순번}/download-attach-files/${저장순번}`, {
        responseType: "blob", // 파일 데이터를 Blob으로 받음
      });

      // Blob 데이터로 URL 생성
      const blobUrl = window.URL.createObjectURL(response.data);
      // 다운로드를 위한 <a> 태그 생성 및 클릭
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.setAttribute("download", 파일명); // 파일명 설정
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // 메모리 해제 및 DOM에서 링크 제거
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("파일 다운로드 중 오류 발생:", error);
      alert("파일 다운로드에 실패했습니다. 다시 시도해주세요.");
    }
  },
  downloadAllAnnounceFile: async (공고: Announce,수주수행구분: string) => {
    try {
      const files = 공고[`${수주수행구분}첨부파일들`].filter((file:AnnounceFile) => file.요청순번 == null && file.자료식별값2 == 수주수행구분);
      if (files.length === 0) {
        alert("다운로드할 파일이 없습니다.");
        return;
      }
      const response = await axiosInstance.get(`announces/${공고.공고순번}/download-attach-multi-files/${수주수행구분}`);

      const zip = new JSZip();
      response.data.forEach((base64Str: string, index: number) => {
        // Base64 디코딩
        const byteCharacters = atob(base64Str);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        // Blob 생성
        const fileBlob = new Blob([new Uint8Array(byteNumbers)], { type: "application/octet-stream" });
        zip.file(files[index].원파일명, fileBlob);
      });
      const blob = await zip.generateAsync({ type: "blob" });
      saveAs(blob, `${공고.공고명}_${수주수행구분}_첨부파일.zip`);
    } catch (error) {
      console.error("파일 다운로드 중 오류 발생:", error);
      alert("파일 다운로드에 실패했습니다. 다시 시도해주세요.");
    }
  },
  contractList: async (seq: number) => {
    return await axiosInstance.get(`announces/contracts/${seq}`);
  },
  contractFile: async (공고순번: number | string, 저장순번: number) => {
    return await axiosInstance.get(`announces/${공고순번}/contract-attach-files/${저장순번}`).catch((error)=> {
      console.error("파일 다운로드 중 오류 발생:", error);
      alert("파일 다운로드에 실패했습니다. 다시 시도해주세요.");
    });
  },
  contractUploadFile: async (seq: number, dtoPart: string, multifiles: File) => {
    const formData = new FormData();

    formData.append("remark", dtoPart);

    formData.append("multipart", multifiles);

    // 요청 보내기
    return axiosInstance.post(`announces/${seq}/contract-sign`, formData);
  },
  sealFile: async (공고순번: string,저장순번:number) => {
    return await axiosInstance.get(`announces/${공고순번}/seal-attach-files/${저장순번}`).catch((error)=> {
      console.error("파일 다운로드 중 오류 발생:", error);
      alert("파일 다운로드에 실패했습니다. 다시 시도해주세요.");
    });
  },
  
  deleteAnnounceFile: async (공고순번: number, 저장순번: number) => {
    try {
      const response = await axiosInstance.delete(`announces/${공고순번}/attach-files/${저장순번}`);
      return response.data; // API의 응답 데이터를 반환
    } catch (error) {
      console.error("첨부파일 삭제 중 오류 발생:", error);
      alert("첨부파일 삭제에 실패했습니다. 다시 시도해주세요.");
      throw error; // 필요시 호출 측에서 추가 처리 가능
    }
  },

  modifyContact: async (data: any, 공고순번: number) => {
    return await axiosInstance.patch(`announces/${공고순번}`, data);
  },

  memoDetail: async (seq: number) => {
    return await axiosInstance.get(`announces/memos/${seq}`);
  },
  addMemo: async (data: any) => {
    return await axiosInstance.post("announces/memos", data);
  },

  savePayment: async (seq: number, data: any) => {
    return await axiosInstance.post(`announces/payment/${seq}`, data);
  },
  contractSign: async (공고순번:number | string,seq: number | string,seq2: number, data: any) => {
    
    const formData = new FormData();
    formData.append('multipart', data);
    return await axiosInstance.patch(`announces/${공고순번}/contract-sign/${seq}/${seq2}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
  },
  deleteContract: async (공고순번: number, 계약서순번: number) => {
    return await axiosInstance.delete(`announces/${공고순번}/contract-sign/${계약서순번}`);
  },
  sealAnnounceFile: async (공고순번: string) => {
    return await axiosInstance.get(`announces/${공고순번}/seal-file`, { responseType: 'blob' }).catch((error)=> {
      console.error("파일 다운로드 중 오류 발생:", error);
      alert("파일 다운로드에 실패했습니다. 다시 시도해주세요.");
    })
  }
  // deletePayment
};
